import type { Partner } from "@expert/shared-types";

export const GLOBAL_CODE_LENGTH = 1;
export const PREFIX_LENGTH = 3;
export const TFN_LENGTH = 10;
export const US = "+1";

export const MDN_MASK = "+{1} (000) 000-0000";
export const VDN_MASK = "000-0000";
export const NO_MASK = "";

export const PHONE_MAX_LENGTH = MDN_MASK.length - 2;
export const VDN_MAX_LENGTH = VDN_MASK.length;

export interface Contact {
    name: string;
    number: string;
    vdn: string;
    group?: Group;
    partner?: Partner | "NOT FOUND";
    isInternal?: boolean;
    // Internal numbers are SIP's that can only be accessed through the Asurion network
}

// We receive data from the CCTS mapping table and normalize it to the
// format we need for EDS
export interface CctsContact {
    friendlyName: string;
    destination: string | number;
    vdn: string;
    partner?: Partner;
    group?: Group;
}

export interface ContactGroup {
    group: Group;
    items: string[];
}

export type Group =
    | "VHDP"
    | "5G"
    | "Claims / Warranty"
    | "Tech Support"
    | "Customer Service"
    | "AT&T"
    | "Unlisted"
    | Partner;

export const vdnToPartner: ReadonlyMap<string, Partner> = new Map<string, Partner>([
    ["1871473", "att"],
    ["1985556", "att"],
    ["1972291", "att"],
    ["1972292", "att"],
    ["1972677", "att"],
    ["6690178", "att"],
    ["1972302", "att"],
    ["1875401", "att"],
    ["1972676", "att"],
    ["1720069", "att"],
    ["1972436", "att"],
    ["1972678", "att"],
    ["1874226", "att"],
    ["1972305", "att"],
    ["1972588", "att"],
    ["1982239", "att"],
    ["1972440", "att"],
    ["1871472", "att"],
    ["6690179", "att"],
    ["1972675", "att"],
    ["1982741", "att"],
    ["1972669", "att"],
    ["1972586", "att"],
    ["1871474", "att"],
]);

export const PhoneNumberFormattedMask = "(###) ###-####";

export interface MaxLengthState {
    enforce: boolean;
    length?: number;
}

export type InputOption = "PhoneNumber" | "Extension" | "SpeedDial" | "None";
